module.exports = __webpack_public_path__ + "img/invoice-de-male-banner-hb.c3088ca3.png";